import styled from 'styled-components'

import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Wrapper = styled.div`
    padding: 50px 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 150px 0;
    }
`

export const ServicesItem = styled.div`
    position: absolute;
    width: calc(100% + 20px);
    height: 100%;
    padding: 30px 50px 30px 30px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    margin-right: -20px;
    /*! @noflip */
    background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 34.44%);
    overflow: hidden;
    transition: 0.3s ease-in-out;
`

export const ItemDescription = styled.div`
    position: relative;
    color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.regular}
    line-height: 25px;
    margin-top: 15px;
    transform: translateY(100%);
    transition: 0.3s ease-in-out;

    @media ${(props) => props.theme.query.min.tablet} {
        line-height: 36px;
    }
`

export const Content = styled.div`
    opacity: 0;
`

export const ServicesItemWrapper = styled.div`
    border-radius: 30px;
    overflow: hidden;
    position: relative;
    height: 450px;

    &:hover {
        ${ServicesItem} {
            /*! @noflip */
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 66.54%, rgba(0, 0, 0, 0) 100%);
            margin-top: 0;
            overflow-y: auto;
        }

        ${Content} {
            opacity: 1;
        }

        ${ItemDescription} {
            transform: translateY(0);
        }
    }
`

export const Title = styled.h2`
    color: ${(props) => props.theme.color.white};
    ${(props) => props.theme.typo.displayM}
    ${(props) => props.theme.fontWeight.bold}
    max-width: 500px;
    position: absolute;
    transform: translateY(-100%);

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayL}
    }
`

export const Link = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.white};
    margin-top: 10px;
    display: block;
    text-decoration: none;
    text-transform: uppercase;

    &:hover {
        color: ${(props) => props.theme.color.a500};

        svg {
            path {
                stroke: ${(props) => props.theme.color.a500};
            }
        }
    }

    svg {
        margin-left: 5px;
    }

    @media ${(props) => props.theme.query.mobile} {
        width: 100%;

        & > div {
            display: block;
            padding: 0px 15px;

            button {
                width: 100%;

                span:first-child {
                    margin: 0px;
                }
            }
        }
    }
`
